import { useStatsigClient } from '@statsig/expo-bindings';
import { useEffect } from 'react';

let stableId: string | undefined;

export const getStatsigStableId = (): string | undefined => stableId;
const setStatsigStableId = (id: string | null | undefined): void => {
    stableId = id != null && id !== '' ? id : undefined;
};

/** Reads the Statsig client stable id while a Statsig provider is mounted. */
export const StatsigStableIdCapture = (): null => {
    const { client } = useStatsigClient();
    const id = client.getContext().stableID;
    useEffect(() => {
        setStatsigStableId(id);
    }, [id]);
    return null;
};
